// TODO: resolve CHCP disables by bot
// eslint-disable-next-line max-classes-per-file
import { Action } from '@ngrx/store';

import {
  UserProfile,
  MfaSkipRequest,
  UserProfileIndicatorName,
  LoginProfileResponseEks,
  AuthMethod,
} from '../user-profile/user-profile.model';

import { ServiceError } from '@cigna/chcp/shared/util';

export enum UserActionTypes {
  GetUserProfile = '[User] Get User Profile',
  GetUserProfileSuccess = '[User] Get User Profile Success',
  GetUserProfileError = '[User] Get User Profile Error',
  GetLoginUserProfile = '[User] Get Login User Profile',
  GetLoginUserProfileSuccess = '[User] Get Login User Profile Success',
  GetLoginUserProfileError = '[User] Get Login User Profile Error',
  UpdateUserProfile = '[User] Update User Profile',
  UpdateUserProfileSuccess = '[User] Update User Profile Success',
  UpdateUserProfileError = '[User] Update User Profile Error',
  UpdateUserProfileIndicator = '[User] Update User Profile Indicator',
  GetSecurityQuestions = '[User] Get Security Questions',
  GetSecurityQuestionsSuccess = '[User] Get Security Questions Success',
  GetSecurityQuestionsError = '[User] Get Security Questions Error',
  UpdateSkipCount = '[User] Update Skip Count',
  UpdateSkipCountSuccess = '[User] Update Skip Count Success',
  UpdateSkipCountError = '[User] Update Skip Count Error',
  HideEmailPopup = '[User] Hide Email Popup',
  UpdateWatchAudit = '[User] Update Watch Audit',
  UpdateWatchAuditSuccess = '[User] Update Watch Audit Success',
  UpdateWatchAuditError = '[User] Update Watch Audit Error',
  UpdateLoginAudit = '[User] Update Login Audit',
  UpdateLoginAuditSuccess = '[User] Update Login Audit Success',
  UpdateLoginAuditError = '[User] Update Login Audit Error',
  GetAuthMethodsStatus = '[OnlineAccess] Get Status of Email and Mobile',
  GetAuthMethodsStatusSuccess = '[OnlineAccess] Get Status of Email and Mobile Success',
  GetAuthMethodsStatusError = '[OnlineAccess] Get Status of Email and Mobile Error',
  UpdateChcpAppAgreed = '[User] Update CHCP App Agreed True',
  UpdateChcpWamAgreed = '[User] Update CHCP Wam Agreed True',
  UpdateEppAppAgreed = '[User] Update EPP App Agreed True',
  UpdateEppWamAgreed = '[User] Update EPP Wam Agreed True',
}

export class GetUserProfile implements Action {
  readonly type = UserActionTypes.GetUserProfile;
}

export class GetUserProfileSuccess implements Action {
  readonly type = UserActionTypes.GetUserProfileSuccess;
  constructor(public payload: UserProfile) {}
}

export class GetUserProfileError implements Action {
  readonly type = UserActionTypes.GetUserProfileError;
  constructor(public payload: ServiceError) {}
}

export class GetLoginUserProfile implements Action {
  readonly type = UserActionTypes.GetLoginUserProfile;
}

export class GetLoginUserProfileSuccess implements Action {
  readonly type = UserActionTypes.GetLoginUserProfileSuccess;
  constructor(public payload: LoginProfileResponseEks) {}
}

export class GetLoginUserProfileError implements Action {
  readonly type = UserActionTypes.GetLoginUserProfileError;
  constructor(public payload: ServiceError) {}
}

export class UpdateUserProfile implements Action {
  readonly type = UserActionTypes.UpdateUserProfile;
  constructor(public payload: Partial<UserProfile>) {}
}

export class UpdateUserProfileSuccess implements Action {
  readonly type = UserActionTypes.UpdateUserProfileSuccess;
  constructor(public payload: Partial<UserProfile>) {}
}

export class UpdateUserProfileError implements Action {
  readonly type = UserActionTypes.UpdateUserProfileError;
  constructor(public payload: ServiceError) {}
}

export class UpdateUserProfileIndicator implements Action {
  readonly type = UserActionTypes.UpdateUserProfileIndicator;
  constructor(public payload: UserProfileIndicatorName) {}
}

export class GetSecurityQuestions implements Action {
  readonly type = UserActionTypes.GetSecurityQuestions;
}

export class GetSecurityQuestionsSuccess implements Action {
  readonly type = UserActionTypes.GetSecurityQuestionsSuccess;
  constructor(public payload: string[]) {}
}

export class GetSecurityQuestionsError implements Action {
  readonly type = UserActionTypes.GetSecurityQuestionsError;
  constructor(public payload: any) {}
}

export class UpdateSkipCount implements Action {
  readonly type = UserActionTypes.UpdateSkipCount;
  constructor(public payload: MfaSkipRequest) {}
}

export class UpdateSkipCountSuccess implements Action {
  readonly type = UserActionTypes.UpdateSkipCountSuccess;
  constructor(public payload: Partial<UserProfile>) {}
}

export class UpdateSkipCountError implements Action {
  readonly type = UserActionTypes.UpdateSkipCountError;
}

export class HideEmailPopup implements Action {
  readonly type = UserActionTypes.HideEmailPopup;
}

export class UpdateWatchAudit implements Action {
  readonly type = UserActionTypes.UpdateWatchAudit;
}

export class UpdateWatchAuditSuccess implements Action {
  readonly type = UserActionTypes.UpdateWatchAuditSuccess;
}

export class UpdateWatchAuditError implements Action {
  readonly type = UserActionTypes.UpdateWatchAuditError;
  constructor(public payload: ServiceError) {}
}

export class UpdateLoginAudit implements Action {
  readonly type = UserActionTypes.UpdateLoginAudit;
}

export class UpdateLoginAuditSuccess implements Action {
  readonly type = UserActionTypes.UpdateLoginAuditSuccess;
}

export class UpdateLoginAuditError implements Action {
  readonly type = UserActionTypes.UpdateLoginAuditError;
  constructor(public payload: ServiceError) {}
}

export class GetAuthMethodsStatus implements Action {
  readonly type = UserActionTypes.GetAuthMethodsStatus;
}

export class GetAuthMethodsStatusSuccess implements Action {
  readonly type = UserActionTypes.GetAuthMethodsStatusSuccess;
  constructor(public payload: AuthMethod[]) {}
}
export class GetAuthMethodsStatusError implements Action {
  readonly type = UserActionTypes.GetAuthMethodsStatusError;
}

export class UpdateChcpAppAgreed implements Action {
  readonly type = UserActionTypes.UpdateChcpAppAgreed;
}
export class UpdateChcpWamAgreed implements Action {
  readonly type = UserActionTypes.UpdateChcpWamAgreed;
}
export class UpdateEppAppAgreed implements Action {
  readonly type = UserActionTypes.UpdateEppAppAgreed;
}
export class UpdateEppWamAgreed implements Action {
  readonly type = UserActionTypes.UpdateEppWamAgreed;
}

export type UserActions =
  | GetUserProfile
  | GetUserProfileSuccess
  | GetUserProfileError
  | GetLoginUserProfile
  | GetLoginUserProfileSuccess
  | GetLoginUserProfileError
  | UpdateUserProfile
  | UpdateUserProfileSuccess
  | UpdateUserProfileError
  | GetSecurityQuestions
  | GetSecurityQuestionsSuccess
  | GetSecurityQuestionsError
  | UpdateSkipCount
  | UpdateSkipCountSuccess
  | UpdateSkipCountError
  | HideEmailPopup
  | UpdateWatchAudit
  | UpdateWatchAuditSuccess
  | UpdateWatchAuditError
  | UpdateLoginAudit
  | UpdateLoginAuditSuccess
  | UpdateLoginAuditError
  | GetAuthMethodsStatus
  | GetAuthMethodsStatusSuccess
  | GetAuthMethodsStatusError
  | UpdateChcpAppAgreed
  | UpdateEppAppAgreed
  | UpdateChcpWamAgreed
  | UpdateEppWamAgreed;
